import { YPaymentAmount } from '../y/amount';
import { $api } from '../y/api';
import { YId, YPaymentProvider, YTimeString } from '../y/types';
import { EUserTransactionKind } from './e-user-transaction';

export interface EPaymentIntent {
    id: YId;
    token: string;
    transaction_kind: EUserTransactionKind;
    user_id?: YId;
    is_test: boolean;
    amount: YPaymentAmount;
    provider?: YPaymentProvider;
    provider_id?: string;
    provider_data?: { url?: string, client_secret?: string };
    supported_providers: YPaymentProvider[];
}

export interface EPaymentIntentAdminView {
    id: YId;
    country: YId;
    is_test: boolean;
    name: string;
    email: string;
    kind: EUserTransactionKind;
    status: string;
    provider: YPaymentProvider;
    amount: YPaymentAmount;
    created_at: YTimeString;
}

export type EMaybePaymentIntent<Data> = { intent: EPaymentIntent, data?: undefined } | { data: Data, intent?: undefined };

export function eIntentGetResponse<Data>(intent: EPaymentIntent) {
    return $api.GET<Data>(`e/payment_intent/${intent.id}/${intent.token}/response`);
}

export function eIntentSetProvider(intent: EPaymentIntent, provider: YPaymentProvider) {
    return $api.POST<EPaymentIntent>(`e/payment_intent/${intent.id}/${intent.token}/provider`, { provider });
}

let all_payment_intents_promise: Promise<EPaymentIntentAdminView[]> | undefined;

export function ePaymentIntentsGetAdminView(reload?: boolean) {
    if(!all_payment_intents_promise || reload) {
        all_payment_intents_promise = $api.GET<EPaymentIntentAdminView[]>('e/payment_intents/admin_view');
    }

    return all_payment_intents_promise;
}
